<template>
  <div
    v-if="show"
    class="search-modal-backdrop"
    @click="$emit('close')"
  >
    <div class="search-modal" @click.stop>
      <div class="search-modal-header">
        <h5>Відкрити тікет</h5>
        <button @click="$emit('close')" class="close-btn">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <div class="search-modal-body">
        <div class="search-input-wrapper">
          <i class="mdi mdi-magnify search-icon"></i>
          <input
            v-model="localSearchQuery"
            @input="handleSearch"
            type="text"
            class="search-input"
            placeholder="Пошук за номером або назвою тікету..."
            autofocus
          />
        </div>
        <div class="tickets-list">
          <div
            v-for="ticket in tickets"
            :key="ticket.ticketId"
            class="ticket-item"
            @click="$emit('open-ticket', ticket.ticketId)"
          >
            <div class="ticket-item-header">
              <span class="ticket-id">#{{ ticket.ticketId }}</span>
              <span :class="['ticket-status', `status-${ticket.status}`]">
                {{ ticket.status }}
              </span>
            </div>
            <div class="ticket-item-title">{{ ticket.ticketName }}</div>
            <div class="ticket-item-meta">
              <span>{{ ticket.type }}</span>
              <span>•</span>
              <span>{{ ticket.createDatetime }}</span>
            </div>
          </div>
          <div
            v-if="localSearchQuery && tickets.length === 0"
            class="no-results"
          >
            <i class="mdi mdi-alert-circle-outline"></i>
            <p>Тікети не знайдено</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TicketSearchModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    tickets: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: "",
    },
  },
  emits: ["close", "search", "open-ticket"],
  data() {
    return {
      localSearchQuery: this.searchQuery,
    };
  },
  watch: {
    searchQuery(newVal) {
      this.localSearchQuery = newVal;
    },
  },
  methods: {
    handleSearch() {
      this.$emit("search", this.localSearchQuery);
    },
  },
};
</script>

<style scoped>
.search-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-modal {
  width: 600px;
  max-height: 80vh;
  background: white;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
}

.search-modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}

.close-btn:hover {
  background: #f8f9fa;
  color: #212529;
}

.search-modal-body {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.search-input-wrapper {
  position: relative;
  padding: 16px 24px;
  border-bottom: 1px solid #e9ecef;
}

.search-icon {
  position: absolute;
  left: 36px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 20px;
}

.search-input {
  width: 100%;
  padding: 10px 12px 10px 36px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.search-input:focus {
  border-color: #1abc9c;
}

.tickets-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.ticket-item {
  padding: 12px 16px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.ticket-item:hover {
  background: #f8f9fa;
  border-color: #1abc9c;
  transform: translateX(4px);
}

.ticket-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ticket-id {
  font-weight: 600;
  color: #1abc9c;
  font-size: 14px;
}

.ticket-status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
}

.status-new {
  background: #e3f2fd;
  color: #1976d2;
}

.status-in_job {
  background: #fff3e0;
  color: #f57c00;
}

.status-decided {
  background: #e8f5e9;
  color: #388e3c;
}

.ticket-item-title {
  font-size: 14px;
  color: #212529;
  margin-bottom: 6px;
  font-weight: 500;
}

.ticket-item-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #6c757d;
}

.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: #6c757d;
}

.no-results i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.no-results p {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 768px) {
  .search-modal {
    width: 90%;
    max-width: 500px;
  }

  .search-modal-header {
    padding: 16px 20px;
  }

  .search-modal-header h5 {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .search-modal {
    width: 95%;
    max-height: 90vh;
  }

  .search-modal-header {
    padding: 12px 16px;
  }

  .search-modal-header h5 {
    font-size: 15px;
  }
}
</style>
